
import { BackgroundGradientAnimation } from "@/components/ui/background-gradient-animation";
import { Header } from "@/components/layout/Header";
import { Sidebar } from "@/components/layout/Sidebar";

export function DashboardLoading() {
  return (
    <div className="w-full h-screen overflow-hidden">
      <BackgroundGradientAnimation>
        <div className="flex flex-col w-full h-screen overflow-hidden">
          <Header 
            avatar="/placeholder.svg" 
            name="Loading..." 
          />
          <div className="flex flex-1 w-full overflow-hidden">
            <Sidebar />
            <div className="flex-1 overflow-y-auto w-full">
              <main className="p-6 space-y-6">
                <div>
                  <h2 className="text-xl text-white/70">Welcome,</h2>
                  <h1 className="text-3xl font-bold tracking-tight text-white">Loading...</h1>
                </div>

                {/* Loading state metrics */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  {[1, 2, 3].map((_, index) => (
                    <div key={index} className="bg-white/10 border border-white/20 rounded-lg p-4 h-[180px] animate-pulse" />
                  ))}
                </div>
              </main>
            </div>
          </div>
        </div>
      </BackgroundGradientAnimation>
    </div>
  );
}
